import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VirtualRouteComponent } from './components/virtual-route/virtual-route.component';
import { InfoPageComponent } from './main/info-page/info-page.component';
import { TabitPayComponent } from './tabit-pay/tabit-pay.component';

import { SharedOrderCreateComponent } from 'src/app/shared-order/shared-order-create/shared-order-create.component';
import { SharedOrderJoinComponent } from 'src/app/shared-order/shared-order-join/shared-order-join.component';
import { SharedOrderManageComponent } from 'src/app/shared-order/shared-order-manage/shared-order-manage.component';

import { OrderItemsComponent } from 'src/app/order-items/order-items.component';
import { TabitOrderComponent } from 'src/app/tabit-order/tabit-order.component';

import {
	AuthGuardService as AuthGuard
} from './_core/auth-guard.service';

const routes: Routes = [
	//{ path: '', redirectTo: '/pay/tabit-pay', pathMatch: 'full' },

	{ path: 'info', component: InfoPageComponent},

	{
		path: 'pay', component: VirtualRouteComponent, canActivate: [AuthGuard], children: [
			{ path: '', redirectTo: 'tabit-pay', pathMatch: 'full' },
			{ path: 'tabit-pay', component: TabitPayComponent, canActivate: [AuthGuard], data: { hideNavBar: true } },
		]
	},
	{
		path: 'taborder', component: VirtualRouteComponent, canActivate: [AuthGuard], children: [
			{ path: '', redirectTo: 'create', pathMatch: 'full' },
			{ path: 'create', component: SharedOrderCreateComponent, canActivate: [AuthGuard] },
			{ path: 'join', component: SharedOrderJoinComponent, canActivate: [AuthGuard] },
			{ path: 'manage', component: SharedOrderManageComponent, canActivate: [AuthGuard] },
		]
	},
	{
		path: 'additems', component: OrderItemsComponent, canActivate: [AuthGuard]
	},
	{
		path: 'orderin', component: TabitOrderComponent, canActivate: [AuthGuard]
	},
	{
		path: 'opentab', component: TabitOrderComponent, canActivate: [AuthGuard]
	},

	{
		path: 'profile', component: VirtualRouteComponent, canActivate: [AuthGuard], children: [
			{ path: '', redirectTo: 'my-profile', pathMatch: 'full' },
		]
	},


];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		useHash: true,
		paramsInheritanceStrategy: 'always',
		//useHash: true
	})],
	exports: [RouterModule]
})

export class AppRoutingModule {
}
